/**
 * Created by YingJieCHAI on 2017/11/17.
 */
import { Component } from "@angular/core";
import { NavService } from "../nav.service";
import { OnInit } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { HttpHeaders } from "@angular/common/http";
import { Http } from "@angular/http";
import "rxjs/add/operator/map"; //调用映射的响应可观察到得到解析的人对象。
//import { Response } from '@angular/http';
declare var $: any;
declare var jQuery: any;
//declare var $:JQueryStatic;
@Component({
  templateUrl: "./home.component.html",
  styleUrls: ["./home.component.css"],
})
export class HomeComponent {
  HomeNewsData: Object;
  HomeJobData: Object;
  HomeHotData: Object;
  HomeLatestData: Object;
  HomeBestData: Object;
  HomeActData: Object; //活动沙龙
  HomeAnswerData: Object; //热门问答
  HomeFineData: Object; //精品干货
  HomeActDataimg; //活动沙龙图片
  HomeAnswerDataimg; //热门问答图片
  HomeFineDataimg; //精品干货图片
  HomeActDatatid; //活动沙龙图片类型id
  HomeActDataid; //活动沙龙单个信息id
  HomeAnswerDatatid;
  HomeAnswerDataid;
  HomeFineDatatid;
  HomeFineDataid;
  HomeTeacherData;
  Homecareerf; //五条职业路径
  causalarr; //关于轮播的数据
  url: string;
  isHot: boolean;
  isLatest: boolean;
  isBest: boolean;
  // 补充数据
  topnewimg; // 顶部新闻图片
  topnewurl; // 顶部新闻链接
  topnewtit; //顶部新闻的标题
  authenbannerimg; //认证培训banner图
  authenbannerurl; //认证培训bannerurl
  authendata; //认证培训数据集合
  carrerbannerimg; //职业规划banner图
  carrerbannerurl; //职业规划banner地址链接
  traindata; //精品集训数据集合
  bannertopimg; //热门课程上面图片
  bannertopurl; //热门课程上面图片
  bannerbottomimg; //热门课程上面图片
  bannerbottomurl; //热门课程上面图片
  MenuData = []; //左侧菜单栏
  NavItem = []; //菜单内容
  // 优化新增
  iSay = false; // "我说等保"栏目展示
  itemShow = false;
  constructor(private http: Http, private NavService: NavService) {}
  ngOnInit() {
    $("title").html(
      "e安在线官网-国内专业网络安全IT人才培训平台_专注于网络安全人才培养_益安在线"
    );
    $("meta[name='description']").attr(
      "content",
      "e安在线-专注于网络安全人才培养，提供1000+免费网络安全培训课程，涵盖云计算,等级保护,web开发和工业互联网安全等课程，培养网络安全领域高端IT人才。"
    );
    $("meta[name='keywords']").attr(
      "content",
      "e安在线,e安在线官网,云计算,信息系统审计师,等级保护,web开发,大数据培训,软件开发,工业互联网安全,北京益安在线"
    );
    // 官网优化去掉之前的轮播机制
    // this.causalFun();
    //初始化热门课程默认显示
    this.isHot = true;
    this.isLatest = false;
    this.isBest = false;
    this.http
      .post(this.NavService.domain_hh + "/bannerad/listBannerad", {})
      .map((res) => res.json())
      .subscribe((res) => {
        this.causalarr = res.data;
        console.log(this.causalarr);
        setTimeout(() => {
          var mySwiper = new Swiper(".swiper-container", {
            direction: "horizontal",
            autoplay: 4000,
            speed: 500,
            pagination: ".swiper-pagination",
            loop: true,
            autoplayDisableOnInteraction: false,
            paginationClickable: true,
            // effect : 'fade'
          });
          $(".swiper-container")
            .mouseenter(function () {
              mySwiper.stopAutoplay();
            })
            .mouseleave(function () {
              mySwiper.startAutoplay();
            });
          console.log(mySwiper);
        }, 200);
      });
    //获取左侧菜单导航
    this.http
      .post(this.NavService.domain + "/pub/portalMenu/getAllMenu", {})
      .map((res) => res.json())
      .subscribe((res) => {
        this.MenuData = res.data.parentData;
        // console.log(this.MenuData);
      });
    //获取首页广告图
    this.http
      .post(this.NavService.domain + "/bannerad/findIndexBanner", {})
      .map((res) => res.json())
      .subscribe((res) => {
        if (res.data.oneRecentTraining.length > 0) {
          this.topnewimg = res.data.oneRecentTraining[0].banner_url;
          this.topnewurl = res.data.oneRecentTraining[0].link;
          this.topnewtit = res.data.oneRecentTraining[0].title;
        }
        if (res.data.oneCertificationTraining.length > 0) {
          this.authenbannerimg =
            res.data.oneCertificationTraining[0].banner_url;
          this.authenbannerurl = res.data.oneCertificationTraining[0].link;
        }
        this.traindata = res.data.fourBoutiqueTraining;
        if (res.data.oneCareerPlanBanner.length > 0) {
          this.carrerbannerimg = res.data.oneCareerPlanBanner[0].banner_url;
          this.carrerbannerurl = res.data.oneCareerPlanBanner[0].link;
        }
        this.authendata = res.data.threeCertificationTraining;
        if (res.data.twoHotCoursesBanner.length > 0) {
          this.bannertopurl = res.data.twoHotCoursesBanner[0].link;
          this.bannertopimg = res.data.twoHotCoursesBanner[0].banner_url;
          this.bannerbottomurl = res.data.twoHotCoursesBanner[1].link;
          this.bannerbottomimg = res.data.twoHotCoursesBanner[1].banner_url;
        }
      });
    //获取首页的新闻资讯内容
    this.http
      .post(this.NavService.domain + "/pub/news/findLeatest5News", {})
      .map((res) => res.json())
      .subscribe((res) => {
        ////console.log(res);
        this.HomeNewsData = res.data;
      });
    //获取首页的热门推荐课程列表
    this.http
      .post(this.NavService.domain + "/pub/course/getIndexCourse", {})
      .map((res) => res.json())
      .subscribe((res) => {
        ////console.log(res);
        this.HomeHotData = res.data.hotCouse;
        this.HomeLatestData = res.data.newestCouse;
        this.HomeBestData = res.data.recommendCouse;
      });

    //获取首页的职业路径五条信息
    this.http
      .post(
        this.NavService.domain + "/pub/careerPlan/findFiveRecmmendCareerPlan",
        {}
      )
      .map((res) => res.json())
      .subscribe((res) => {
        this.Homecareerf = res.data;
        ////console.log(this.Homecareerf);
      });
    //获取首页的招聘指南内容
    //subscribe:订阅可观察到的，以获得解析的人员对象并将其附加到组件上
    this.http
      .post(this.NavService.domain + "/pub/news/findRecruitFourNews", {})
      .map((res) => res.json())
      .subscribe((res) => {
        this.HomeJobData = res.data;
      });
    //获取三张图片
    this.http
      .post(
        this.NavService.domain + "/pub/news/findThreeActivityBannerInfo",
        {}
      )
      .map((res) => res.json())
      .subscribe((res) => {
        // console.log(res.data);
        ////console.log("三张图片");
        if (res.code == 0) {
          this.HomeActDataimg = res.data[0].banner_url; //活动沙龙图片
          this.HomeAnswerDataimg = res.data[1].banner_url; //热门问答图片
          this.HomeFineDataimg = res.data[2].banner_url; //精品干货图片
          this.HomeActDatatid = res.data[0].banner_adver_id; //活动沙龙图片类型id
          this.HomeActDataid = res.data[0].link; //活动沙龙单个信息id
          this.HomeAnswerDatatid = res.data[1].banner_adver_id;
          this.HomeAnswerDataid = res.data[1].link;
          this.HomeFineDatatid = res.data[2].banner_adver_id;
          this.HomeFineDataid = res.data[2].link;
        }
      });
    //获取活动沙龙内容
    this.http
      .post(this.NavService.domain + "/pub/news/findActivityFourNews", {})
      .map((res) => res.json())
      .subscribe((res) => {
        for (var key = 0; key < res.data.length; key++) {
          ////console.log(key);
          if (key == 3) {
            res.data[key].numId = key + 1;
          } else {
            res.data[key].numId = "r" + (key + 1);
          }
        }
        this.HomeActData = res.data;
        ////console.log(res.data);
      });
    //获取热门问答内容 变成 报考指南
    this.http
      .post(this.NavService.domain + "/pub/course/uLikeExam", {})
      .map((res) => res.json())
      .subscribe((res) => {
        res.data = res.data.slice(0, 4);
        for (var key = 0; key < res.data.length; key++) {
          ////console.log(key);
          if (key == 3) {
            res.data[key].numId = key + 1;
          } else {
            res.data[key].numId = "b" + (key + 1);
          }
        }
        this.HomeAnswerData = res.data;
        console.log(this.HomeAnswerData);
      });
    //获取精品干货内容
    this.http
      .post(this.NavService.domain + "/pub/news/findDriedFoodFourNews", {})
      .map((res) => res.json())
      .subscribe((res) => {
        for (var key = 0; key < res.data.length; key++) {
          ////console.log(key);
          if (key == 3) {
            res.data[key].numId = key + 1;
          } else {
            res.data[key].numId = "g" + (key + 1);
          }
        }
        this.HomeFineData = res.data;
        ////console.log(res.data);
      });

    //获取首页讲师信息  前五个讲师
    this.http
      .post(this.NavService.domain_xl + "/teacher/isTopTeacherList", {
        isTop: "1",
        pageNo: "1",
        pageSize: "5",
      })
      .map((res) => res.json())
      .subscribe(
        (res) => {
          ////console.log(res);
          if (res.code == 0) {
            if (res.data.list.length != 0) {
              this.HomeTeacherData = res.data.list;
              var arr = new Array();
              //教训: 每次进来要清数据
              for (var i = 0; i < this.HomeTeacherData.length; i++) {
                if (this.HomeTeacherData[i].isStar == 1) {
                  arr = [];
                  arr.push(true);
                  this.HomeTeacherData[i].show = arr;
                } else if (this.HomeTeacherData[i].isStar == 2) {
                  arr = [];
                  arr.push(true);
                  arr.push(true);
                  this.HomeTeacherData[i].show = arr;
                } else if (this.HomeTeacherData[i].isStar == 3) {
                  arr = [];
                  arr.push(true);
                  arr.push(true);
                  arr.push(true);
                  this.HomeTeacherData[i].show = arr;
                }
              }
            } else {
              this.HomeTeacherData = [];
            }
          } else {
            this.HomeTeacherData = [];
          }
        },
        (error) => {
          this.HomeTeacherData = [];
          ////console.log(error);
        }
      );
  }
  dataHover(value: number) {
    this.itemShow = true;
    if (value == 21) {
      this.iSay = true;
    } else {
      this.iSay = false;
    }
    for (let key in this.MenuData) {
      if (value == this.MenuData[key].id) {
        //console.log(this.MenuData[i].sonData);
        this.NavItem = this.MenuData[key].sonData;
      }
    }
  }
  dataLea() {
    this.itemShow = false;
  }
  //热门课程推荐的动态效果
  hover_hot() {
    ////console.log(1);
    this.isHot = true;
    this.isLatest = false;
    this.isBest = false;
  }
  hover_latest() {
    this.isHot = false;
    this.isLatest = true;
    this.isBest = false;
  }
  hover_best() {
    this.isHot = false;
    this.isLatest = false;
    this.isBest = true;
  }
  // 废弃的轮播逻辑(优化之前的轮播逻辑)
  causalFun() {
    $(".pagation0").addClass("on");
    var banner_timer,
      index = 0,
      onindex = 0;
    $("#banner").on("mouseenter", ".bannernav>ol", function () {
      ////console.log(this);
      clearInterval(banner_timer);
    });
    $("#banner .bannernav>ol")
      .mouseenter(function () {
        //console.log(1);
        clearInterval(banner_timer);
      })
      .mouseleave(function () {
        var bannercur = $(this);
        //console.log($(this));
        banner_timer = setInterval(function () {
          bannercur
            .parent()
            .find("div:visible>a:first")
            .clone(true)
            .appendTo(bannercur.parent().find("div:visible"));
          bannercur
            .parent()
            .find("div:visible")
            .stop()
            .animate({ marginLeft: "-800px" }, 200, function () {
              $(this).find("a:first").remove();
              $(this).css({ marginLeft: 0 });
            });
          index++;
          if (index > bannercur.find("li").length - 1) {
            index = 0;
          }
          bannercur
            .find("li")
            .eq(index)
            .addClass("on")
            .siblings()
            .removeClass("on");
          $(".img-bdarr").find(".imgdiv").hide();
          $(".img-bdarr").find(".imgdiv").eq(index).fadeIn();
        }, 3000);
      })
      .mouseleave();
    $("#banner").on("click", ".bannernav>ol>li", function () {
      //console.log(this);
      $(this).addClass("on").siblings().removeClass("on");
      onindex = $(this).index();
      if (onindex > index) {
        $("#banner .bannernav>div:visible>a")
          .slice(1, onindex - index)
          .css({ width: "0" });
        $("#banner .bannernav>div:visible>a")
          .slice(0, onindex - index)
          .clone(true)
          .appendTo("#banner .bannernav>div:visible");
        $("#banner .bannernav>div:visible")
          .stop()
          .animate({ marginLeft: "-800px" }, 200, function () {
            $("#banner .bannernav>div:visible>a")
              .slice(0, onindex - index)
              .remove();
            $("#banner .bannernav>div:visible>a").css({ width: "800px" });
            $(this).css({ marginLeft: 0 });
            index = onindex;
            $(".img-bdarr").find(".imgdiv").hide();
            $(".img-bdarr").find(".imgdiv").eq(index).fadeIn();
            //console.log($(".img-bdarr").find("img").eq(index).fadeIn());
          });
      } else if (onindex < index - 1) {
        $("#banner .bannernav>div:visible>a")
          .slice(-(index - onindex - 1))
          .css({ width: "0" });
        $("#banner .bannernav>div:visible>a")
          .slice(-(index - onindex))
          .clone(true)
          .prependTo("#banner .bannernav>div:visible");
        $("#banner .bannernav>div:visible").css({ marginLeft: "-800px" });
        $("#banner .bannernav>div:visible")
          .stop()
          .animate({ marginLeft: 0 }, 200, function () {
            $("#banner .bannernav>div:visible>a")
              .slice(-(index - onindex))
              .remove();
            $("#banner .bannernav>div:visible>a").css({ width: "800px" });
            index = onindex;
            $(".img-bdarr").find(".imgdiv").hide();
            $(".img-bdarr").find(".imgdiv").eq(index).fadeIn();
            //console.log($(".img-bdarr").find("img").eq(index).fadeIn());
          });
      } else if (onindex == index - 1) {
        $("#banner .bannernav>div:visible>a")
          .slice(-1)
          .clone(true)
          .prependTo("#banner .bannernav>div:visible");
        $("#banner .bannernav>div:visible").css({ marginLeft: "-8000px" });
        $("#banner .bannernav>div:visible")
          .stop()
          .animate({ marginLeft: 0 }, 200, function () {
            $("#banner .bannernav>div:visible>a").slice(-1).remove();
            $("#banner .bannernav>div:visible>a").css({ width: "800px" });
            index = onindex;
            $(".img-bdarr").find(".imgdiv").hide();
            $(".img-bdarr").find(".imgdiv").eq(index).fadeIn();
            //console.log($(".img-bdarr").find("img").eq(index).fadeIn());
          });
      }
    });
  }
}
